<template>
    <div id="aia_header">
        <MassHeader
            v-if="theme == 'mass'"
            @clickBack="clickBack" />
        <PrestigeHeader
            v-if="theme == 'prestige'"
            @clickBack="clickBack" />
    </div>
</template>
<script>
import MassHeader from './component/MassHeader.vue';
import PrestigeHeader from './component/PrestigeHeader.vue';
export default {
    name: 'AIAHeader',
    components: {
        MassHeader,
        PrestigeHeader
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    methods: {
        //event
        clickBack: function () {
            this.$emit('clickBack');
        }
    }
}
</script>
<style lang="scss">
@import "./AIAHeader.scss";
</style>